import { render, staticRenderFns } from "./SsoUserMenu.vue?vue&type=template&id=8bf6ebac"
import script from "./SsoUserMenu.vue?vue&type=script&lang=js"
export * from "./SsoUserMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports